import { render, staticRenderFns } from "./newsletter-signup.vue?vue&type=template&id=67a2a36e"
import script from "./newsletter-signup.vue?vue&type=script&lang=js"
export * from "./newsletter-signup.vue?vue&type=script&lang=js"
import style0 from "./newsletter-signup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports